import { useContext } from "react";
import { ModalContext } from "react-aria-components";

export const useIsDismissable = () => {
  const modal = useContext(ModalContext);
  return !!modal && "isDismissable" in modal && modal.isDismissable === true;
};
